import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountType } from '../../enums/account-type';
import { AccountTypeLabelPipe } from '../../pipes/account-type-label.pipe';
import { AccountTypeCssPipe } from '../../pipes/account-type-css.pipe';

@Component({
  selector: 'app-account-type',
  imports: [CommonModule, AccountTypeLabelPipe, AccountTypeCssPipe],
  templateUrl: './account-type.component.html',
  styleUrl: './account-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountTypeComponent {
  public readonly type = input.required<AccountType>();
}
